import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { AppearanceService } from '../appearance/appearance.service';
import { Constants } from '../../constants/constants';
import { TabModel } from 'src/app/models/tab.model';


@Injectable({
  providedIn: 'root'
})
export class TabService 
{
  currentTabs: Array<TabModel> = [];
  currentActiveTab: TabModel;
  currentTabSection: string;

 
  constructor(private localStorageService: LocalStorageService,
    private appearanceService: AppearanceService) 
  {
    this.initService();
  }


  initService()
  {
    this.appearanceService.listenForEvent('storage:loaded', (data: any) => {

      this.loadFromLocalData();

    });
  }


  loadFromLocalData() 
  {
    this.currentTabSection = this.localStorageService.getCurentTabSection();

    if (this.currentTabSection)
    {
      this.currentTabs = this.localStorageService.getTabs(this.currentTabSection);
      this.currentActiveTab = this.localStorageService.getActiveTab();

      if (!this.currentActiveTab)
      {
        this.currentActiveTab = this.currentTabs[0];
        this.localStorageService.saveActiveTab(this.currentActiveTab);
      }
    }
  }


  public reloadAllTabs(clientUid, section)
  {
    this.currentTabs = null;
    this.currentActiveTab = null;
    this.currentTabSection = null;
    this.firstLoginSaveTabs(clientUid);
    this.getTabs(section);
  }


  public firstLoginSaveTabs(clientUid)
  {
    var jobTabs = new Array<TabModel>();
    var firstJobTab = this.getNewTab("Jobs", "jobs", clientUid);
    jobTabs.push(firstJobTab);

    this.localStorageService.saveTabs('jobs', jobTabs);

    var alertTabs = new Array<TabModel>();
    var firstAlertTab = this.getNewTab("Alerts", "alerts", clientUid);
    alertTabs.push(firstAlertTab);

    this.localStorageService.saveTabs('alerts', alertTabs);

    var assetTabs = new Array<TabModel>();
    var firstAssetTab = this.getNewTab("Assets", "assetlist", clientUid);
    assetTabs.push(firstAssetTab);

    this.localStorageService.saveTabs('assets', assetTabs);

    var assetTypeTabs = new Array<TabModel>();
    var firstAssetTypeTab = this.getNewTab("Assets Types", "asset-types", clientUid);
    assetTypeTabs.push(firstAssetTypeTab);

    this.localStorageService.saveTabs('asstypes', assetTypeTabs);

    var deviceTabs = new Array<TabModel>();
    var firstDeviceTab = this.getNewTab("Devices", "devices", clientUid);
    deviceTabs.push(firstDeviceTab);

    this.localStorageService.saveTabs('devices', deviceTabs);

    var userTabs = new Array<TabModel>();
    var firstUserTab  = this.getNewTab("Users", "users", clientUid);
    userTabs.push(firstUserTab);

    this.localStorageService.saveTabs('users', userTabs);

    var stockTabs = new Array<TabModel>();
    var firstStockTab  = this.getNewTab("Stock Orders", "stock", clientUid);
    stockTabs.push(firstStockTab);

    this.localStorageService.saveTabs('stock', stockTabs);

    var stockInvTabs = new Array<TabModel>();
    var firstStockInvTab  = this.getNewTab("Stock Inventory", "stockinv", clientUid);
    stockInvTabs.push(firstStockInvTab);

    this.localStorageService.saveTabs('stockinv', stockInvTabs);

    var stockPresetTabs = new Array<TabModel>();
    var firstStockPresetTab  = this.getNewTab("Stock Presets", "stockpreset", clientUid);
    stockPresetTabs.push(firstStockPresetTab);

    this.localStorageService.saveTabs('stockpreset', stockPresetTabs);

    var engineerTabs = new Array<TabModel>();
    var firstEngineerTab  = this.getNewTab("Analytics", "analytics", clientUid);
    engineerTabs.push(firstEngineerTab);
    
    this.localStorageService.saveTabs('analytics', engineerTabs);

    var addressTabs = new Array<TabModel>();
    var firstAddressTab = this.getNewTab("Locations", "locations", clientUid);
    addressTabs.push(firstAddressTab);

    this.localStorageService.saveTabs('locations', addressTabs);

    var observationTabs = new Array<TabModel>();
    var firstObsTab = this.getNewTab("Observations", "observations", clientUid);
    observationTabs.push(firstObsTab);

    this.localStorageService.saveTabs('observations', observationTabs);

    var reportTabs = new Array<TabModel>();
    var firstReportTab = this.getNewTab("Reports", "reports", clientUid);
    reportTabs.push(firstReportTab);

    this.localStorageService.saveTabs('reports', reportTabs);

    var vehicleTabs = new Array<TabModel>();
    var firstVehicleTab = this.getNewTab("Vehicles", "vehicles", clientUid);
    vehicleTabs.push(firstVehicleTab);

    this.localStorageService.saveTabs('vehicles', vehicleTabs);


    var clientTabs                = new Array<TabModel>();
    var firstTab                  = new TabModel();
    firstTab.index                = 0;
    firstTab.name                 = "Client";
    firstTab.uid                  = null;
    firstTab.tabType              = 1;
    firstTab.clientUid            = clientUid;
    firstTab.isEditing            = false;
    firstTab.previousRoute        = null;
    firstTab.activeTab            = true;
    firstTab.currentRoute         = "client";
    clientTabs.push(firstTab);

    var secondTab                  = new TabModel();
    secondTab.index                = 1;
    secondTab.name                 = "Client Config";
    secondTab.uid                  = null;
    secondTab.tabType              = 1;
    secondTab.clientUid            = clientUid;
    secondTab.isEditing            = false;
    secondTab.previousRoute        = null;
    secondTab.activeTab            = false;
    secondTab.currentRoute         = "client";
    clientTabs.push(secondTab);

    var thirdTab                  = new TabModel();
    thirdTab.index                = 2;
    thirdTab.name                 = "Organisation Config";
    thirdTab.uid                  = null;
    thirdTab.tabType              = 1;
    thirdTab.clientUid            = clientUid;
    thirdTab.isEditing            = false;
    thirdTab.previousRoute        = null;
    thirdTab.activeTab            = false;
    thirdTab.currentRoute         = "client";
    clientTabs.push(thirdTab);

    this.localStorageService.saveTabs('client', clientTabs);
  }


  private getNewTab(name, route, clientUid)
  {
    var newTab                  = new TabModel();
    newTab.index                = 0;
    newTab.name                 = name;
    newTab.uid                  = null;
    newTab.tabType              = 1;
    newTab.clientUid            = clientUid;
    newTab.isEditing            = false;
    newTab.previousRoute        = null;
    newTab.activeTab            = false;
    newTab.currentRoute         = route;
    return newTab;
  }


  public setActiveTabs(section)
  {
    this.currentActiveTab = null;
    this.currentTabs = this.localStorageService.getTabs(section);

    for (var i = 0; i < this.currentTabs.length; i++)
    {
      if (this.currentTabs[i].activeTab)
      {
        this.currentActiveTab = this.currentTabs[i];
        break;
      }
    }

    if (!this.currentActiveTab && this.currentTabs[0])
    {
      this.currentActiveTab = this.currentTabs[0];
      this.currentTabs[0].activeTab = true;
      this.localStorageService.saveTabs(section, this.currentTabs);
    }

    this.localStorageService.saveActiveTab(this.currentActiveTab);

    this.currentTabSection = section;
  }


  public getTabs(section): Array<TabModel> 
  { 
    if (this.currentTabSection == section)
    {
      return this.currentTabs;
    }

    this.currentTabs = this.localStorageService.getTabs(section);

    return this.currentTabs;
  }


  public saveTabs(section, tabs): any 
  { 
    this.localStorageService.saveTabs(section, tabs);
    this.currentTabs = tabs;
  }


  public closeTab(index): TabModel
  {
    var prevTabIndex = 0;
    var currentlyActiveTab = false;
    var section = this.currentTabs[0].currentRoute;

    if (index > 0)
    {
      for (var i = 0; i < this.currentTabs.length; i++)
      {
          if (this.currentTabs[i].index == index)
          {
            if (i > 0)
            {
              if (this.currentTabs[i].activeTab)
              {
                prevTabIndex = i - 1;
                currentlyActiveTab = true;
              }
            }

            this.currentTabs.splice(i, 1);
            break;
          }
      }

      if (currentlyActiveTab)
      {
        var newActiveTab = this.currentTabs[prevTabIndex];
        newActiveTab.activeTab = true;
      }
  
      this.localStorageService.saveTabs(section, this.currentTabs);
    }

    if (!currentlyActiveTab)
    {
      return null;
    }

    this.currentActiveTab = this.currentTabs[prevTabIndex];
    this.localStorageService.saveActiveTab(this.currentActiveTab);

    return this.currentTabs[prevTabIndex];
  }


  public pushNewTab(name, uid, tabType): TabModel
  {
    var section = this.currentTabs[0].currentRoute;
    var clientUid = this.currentTabs[0].clientUid;

    var newTab            = new TabModel();
    newTab.index          = this.currentTabs.length;
    newTab.name           = name;
    newTab.uid            = uid;
    newTab.tabType        = tabType;
    newTab.clientUid      = clientUid;
    newTab.isEditing      = false;
    newTab.previousRoute  = null;
    newTab.currentRoute   = section;

    this.currentTabs.push(newTab);

    return newTab;
  }


  public setTabAsActive(index)
  {
    var section = this.currentTabs[0].currentRoute;

    for (var i = 0; i < this.currentTabs.length; i++)
    {
        if (this.currentTabs[i].index == index)
        {
          this.currentTabs[i].activeTab = true;
          this.currentActiveTab = this.currentTabs[i];
          this.localStorageService.saveActiveTab(this.currentActiveTab);
        }
        else
        {
          this.currentTabs[i].activeTab = false;
        }
    }
  
    this.localStorageService.saveTabs(section, this.currentTabs);
  }


  public isTabOpen(uid)
  {
    for (var i = 0; i < this.currentTabs.length; i++)
    {
        if (this.currentTabs[i].uid == uid)
        {
          return true;
        }
    }

    return false;
  }


  public getTabByUid(uid)
  {
    for (var i = 0; i < this.currentTabs.length; i++)
    {
        if (this.currentTabs[i].uid == uid)
        {
          return this.currentTabs[i];
        }
    }
  
    return null;
  }


  public getCurrentActiveTabIndex(): number
  {
    if (this.currentActiveTab)
    {
      return this.currentActiveTab.index;
    }

    return 0;
  }


  public getCurrentActiveTab(): TabModel
  {
    if (this.currentActiveTab)
    {
      return this.currentActiveTab;
    }

    return this.currentTabs[0];
  }



}
